export const fetchAll = {
  pathname: () => '/delivery_profiles',
}

export const fetchProfile = {
  pathname: ({ id }) => `/delivery_profiles/${id}`,
}

export const createProfile = {
  pathname: () => '/delivery_profiles',
  method: 'POST',
  headers: {
    'content-type': 'application/json',
  },
  body: ({ profile }) => ({ profile })
}

export const updateProfile = {
  pathname: ({ id }) => `/delivery_profiles/${id}`,
  method: 'PUT',
  headers: {
    'content-type': 'application/json',
  },
  body: ({ profile }) => ({ profile })
}

export const activateProfile = {
  pathname: ({ id }) => `/delivery_profiles/${id}/activate`,
  method: 'PUT',
  headers: {
    'content-type': 'application/json',
  },
  body: ({ active }) => ({ active })
}

export const deleteProfile = {
  pathname: ({ id }) => `/delivery_profiles/${id}`,
  method: 'DELETE',
  headers: {
    'content-type': 'application/json',
  }
}
